export const SocialMediaScraperExtId: string =
  "ibicikdcenbohaobhfhmjnhphkooehhf";
export const GoogleScraperExtId: string = "gbclkmimfbegngecplnnoiclffhidmdk";
export const SalvageYardID: string = "npcpfngjddnpnodcdjcfbfchgjgalhko";
